import { stripNoLinkedCardQuery } from "./strip-no-linked-card-query";

export const forwardUrl = (originalUrl: string, actionValue?: string): string => {
    const forwardSearch = stripNoLinkedCardQuery(window.location.search); 
    let forwardUrl = `${window.location.pathname}${forwardSearch}`;

    if(actionValue) {
        forwardUrl = addQueryParameter(forwardUrl, 'action', actionValue);
    }

    forwardUrl += window.location.hash;

    return addQueryParameter(originalUrl, 'forward', encodeURIComponent(forwardUrl));
};

const addQueryParameter = (url: string, key: string, value: string): string => {
    return `${url}${url.includes('?') ? '&' : '?'}${key}=${value}`;
};